"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerAnimationSystem = exports.DefaultPlayerColliders = void 0;
const gotti_1 = require("gotti");
const Constants_1 = require("../../../Shared/Constants");
const types_1 = require("../../../Shared/types");
const DefaultPlayerColliders = (tags) => [
    { layer: 1, shapeData: { x: 10, y: 25, r: 6 }, dynamic: true, tags },
    { layer: 1, shapeData: { x: -35, y: -35, w: 90, h: 90 }, tags: ['sort'], dynamic: true, data: { sortOffsetTop: 15 } }
];
exports.DefaultPlayerColliders = DefaultPlayerColliders;
class PlayerAnimationSystem extends gotti_1.ClientSystem {
    constructor() {
        super(Constants_1.SYSTEMS.PLAYER_ANIMATION);
        this.uninitComponents = [];
        this.readyEntities = [];
        this.needsSort = false;
        const doSort = (colliderA, colliderB) => {
            var _a;
            if (colliderA.gameObject.layerIndex === colliderB.gameObject.layerIndex) {
                const spriteA = colliderA.gameObject.delegatedSprite || colliderA.gameObject;
                const spriteB = colliderB.gameObject.delegatedSprite || colliderB.gameObject;
                const parentA = spriteA.parent;
                const parentB = spriteB.parent;
                if (parentA !== parentB)
                    throw new Error(`Expected to be the same parents.`);
                const parent = parentA;
                const indexA = parent.children.indexOf(spriteA);
                const indexB = parent.children.indexOf(spriteB);
                const spriteOffsetTop = ((_a = colliderA.data) === null || _a === void 0 ? void 0 : _a.sortOffsetTop) || 0;
                const spriteSortPoint = (spriteA.y + (spriteA.height / 2) + spriteOffsetTop);
                if (spriteSortPoint > spriteB.y + spriteB.height) {
                    if (indexA < indexB) {
                        parentA.setChildIndex(spriteA, indexB);
                    }
                }
                else {
                    if (indexA > indexB) {
                        parentA.setChildIndex(spriteA, Math.max(indexB - 1, 0));
                    }
                }
            }
        };
        let playerCollider;
        let lowestCollider;
        let lowestPoint;
        this.sortCollisionPlugin = {
            type: 'collision',
            name: 'sort',
            tagAs: [Constants_1.COLLIDER_TAGS.sort],
            tagBs: [Constants_1.COLLIDER_TAGS.furniture, Constants_1.COLLIDER_TAGS.tree_stump, Constants_1.COLLIDER_TAGS.flower, Constants_1.COLLIDER_TAGS.dropped_item, Constants_1.COLLIDER_TAGS.building, Constants_1.COLLIDER_TAGS.npc, Constants_1.COLLIDER_TAGS.hole],
            onCollision: (colliderA, colliderB) => {
                doSort(colliderA, colliderB);
            },
            onCollisionStart(colliderA, colliderB) {
                doSort(colliderA, colliderB);
            },
            onAddedColliderWithTagB: () => {
                this.needsSort = true;
            },
        };
    }
    onClear() {
    }
    onLocalMessage(message) { }
    onServerMessage(message) {
    }
    onInit() {
        this.globals.tileWorld.use(this.sortCollisionPlugin);
    }
    onEntityAddedComponent(entity, component) {
        //   //console.error('added ani component.')
        if (!entity.hasComponent(Constants_1.SYSTEMS.PLAYER_MOVEMENT) && !entity.hasComponent(Constants_1.SYSTEMS.NPC_MOVEMENT)) {
            //console.error(entity);
            throw new Error(`Expected entity to have a player movement component added before the player animation component.`);
        }
        this.uninitComponents.push(component);
        entity.once('skeleton-ready', (skeleton) => {
            this.uninitComponents = this.uninitComponents.filter(c => c !== component);
            this.readyEntities.push(entity);
            const p = entity.getComponent(Constants_1.SYSTEMS.POSITION).getPosition();
            skeleton.x = p.x;
            skeleton.y = p.y;
            const tags = [];
            let colliderArray;
            if (entity.type === types_1.EntityTypes.ClientPlayer) {
                tags.push('client_player', 'player');
                colliderArray = exports.DefaultPlayerColliders(tags);
                colliderArray.push({ layer: 1, shapeData: { x: 10, y: 18, r: 40 }, dynamic: true, tags: [Constants_1.COLLIDER_TAGS.client_player_bug_detector] });
                // we have special logic for police npcs so do not add colliders to gameobject here, we do it inside the Police Assemblage.
            }
            else if (entity.type === types_1.EntityTypes.NPC) {
                tags.push(Constants_1.COLLIDER_TAGS.npc);
                colliderArray = exports.DefaultPlayerColliders(tags);
            }
            entity['gameObject'] = this.globals.tileWorld.addGameObject({
                sprite: skeleton,
                layer: 1,
                colliders: colliderArray,
            });
            entity['gameObject']['entity'] = entity;
            entity.emit('gameobject-ready', entity.gameObject);
        });
        component.initSkeleton(this.globals.gottimation, this.globals.gameStateData.direction);
    }
    onEntityRemovedComponent(entity, component) {
        if (component.isReady()) {
            entity.gameObject.removeFromMap();
            delete entity['gameObject']['entity'];
            delete entity['gameObject'];
            this.readyEntities = this.readyEntities.filter(e => e !== entity);
        }
        else {
            this.uninitComponents = this.uninitComponents.filter(c => c !== component);
        }
    }
    update(delta) {
        var _a, _b;
        const normalizedDelta = delta * 1000;
        for (let i = 0; i < this.readyEntities.length; i++) {
            const c = this.getSystemComponent(this.readyEntities[i]);
            if (this.readyEntities[i].hasComponent(Constants_1.SYSTEMS.PLAYER_MOVEMENT)) {
                const actionComponent = this.readyEntities[i].getComponent(Constants_1.SYSTEMS.PLAYER_ACTION);
                c.updateAnimation(normalizedDelta, actionComponent);
            }
            else {
                c.skeleton.update(normalizedDelta);
            }
        }
        if (this.needsSort) {
            const playerSprite = (_b = (_a = this.globals.clientPlayer) === null || _a === void 0 ? void 0 : _a.gameObject) === null || _b === void 0 ? void 0 : _b.sprite;
            if (playerSprite) {
                playerSprite.parent.children.sort((spriteA, spriteB) => {
                    if (spriteA === playerSprite || spriteB === playerSprite)
                        return 0;
                    return (spriteA.y + spriteA.height) - (spriteB.y + spriteB.height);
                });
            }
            this.needsSort = false;
        }
    }
    onPeerMessage(peerId, message) {
    }
}
exports.PlayerAnimationSystem = PlayerAnimationSystem;
//# sourceMappingURL=module.js.map